/**
 * A section's props as a string that a save round trip doesn't change: the
 * server drops empty objects and undefined values (Mongoose "minimize"), and
 * key order isn't meaningful. The inspector uses it to tell its own edits
 * coming back from an outside change such as undo.
 */
type Json = null | boolean | number | string | Json[] | { [key: string]: Json };

const normalize = (value: unknown): Json | undefined => {
  if (value === undefined || typeof value === 'function') return undefined;
  if (value === null || typeof value !== 'object') return value as Json;
  if (Array.isArray(value)) return value.map(v => (normalize(v) === undefined ? null : normalize(v) as Json));
  if (value instanceof Date) return value.toISOString();
  const out: { [key: string]: Json } = {};
  Object.keys(value as Record<string, unknown>).sort().forEach((key) => {
    const v = normalize((value as Record<string, unknown>)[key]);
    if (v !== undefined) out[key] = v;
  });
  return Object.keys(out).length ? out : undefined;
};

export const propsSignature = (props: unknown): string => JSON.stringify(normalize(props) === undefined ? null : normalize(props));
